import { z } from "zod"

import { PricingNumericTypeValues } from "@/screens/Pricing/constants"

export const BulkUpdateSchema = z.object({
  acceptedCost: z.number().optional().nullable(),
  acceptedCostType: z.nativeEnum(PricingNumericTypeValues).optional(),
  includeMargin: z.boolean().optional(),
  priceChange: z.number().optional().nullable(),
  priceChangeType: z.nativeEnum(PricingNumericTypeValues).optional(),
  expirationDate: z.string().nullable().optional(),
  effectiveDate: z.string().nullable().optional(),
})

export type BulkUpdateFormValues = z.infer<typeof BulkUpdateSchema>
